import clsx from "clsx";
import { LucideIcon } from "lucide-react";
import React from "react";
import { AppText } from "@/components/Text/AppText";

interface CreateModeOptionProps {
    icon: LucideIcon;
    title: string;
    description: string;
    isSelected: boolean;
    onClick: () => void;
}

export const CreateModeOption: React.FC<CreateModeOptionProps> = ({
    icon: Icon,
    title,
    description,
    isSelected,
    onClick,
}) => (
    <button
        type="button"
        onClick={onClick}
        className={clsx(
            "flex flex-col items-center rounded-xl border-2 p-4 text-left transition-all sm:p-4",
            isSelected ? "border-primary-700" : "border-neutral-300",
        )}
    >
        <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary-700">
            <Icon className="h-8 w-8 text-neutral-50" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
            <AppText
                variant="subheadings"
                className="text-neutral-900"
            >
                {title}
            </AppText>
            <AppText
                variant="regular"
                className="text-neutral-700"
            >
                {description}
            </AppText>
        </div>
    </button>
);
